// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_8r-1";
export var dragButton = "_8r-5";
export var sortableCell = "_8r-4";
export var sortableNameCell = "_8r-3";
export var sortableRow = "_8r-0";
export var tableHeader = "_8r-6";
export var tableHeaderWithCardHeader = "_8r-7";
export var weightInputRow = "_8r-2";